module.exports = __webpack_public_path__ + "static/media/manu-10.55715a8a.png";